export default __webpack_public_path__ + "static/media/Overdue.53f992b5.svg";